<template>
  <div class="overlay fixed top-0 left-0 w-screen h-full z-10">
    <!--
      tall:overflow-y-hidden used to sit alongside overflow-y-auto on the card
      below. Same trap as common/Screen.vue: `tall` is a min-height query, so
      above 750px it turned off scrolling on a card that still has a hard
      max-height: calc(99% - env(safe-area-inset-top)). Nothing overflows its
      card today, but the sheets passing height 97% (EditProfile) or 80%
      (DatePicker, HomePage/Discover) have very little room left to grow into.
    -->
    <div
      class="card-wrapper overflow-x-hidden flex flex-col items-center absolute left-0 bottom-0 w-full bg-white overflow-y-auto"
      :style="{ 'min-height': height }"
    >
      <div v-if="!noHead" class="relative text-center w-full text-xl mt-5 mb-8" :style="headStyle">
        <div
          v-if="showLeftBtn"
          class="back-btn absolute"
          @click="$emit('back-handler')"
          style="margin: -1rem; padding: 1rem;"
        >
          <img class="md:w-3" src="../../assets/common/back-icon.svg" alt="back button" />
        </div>
        <div
          class="sm:text-2xl"
          :style="{ 'padding-top': padding ? '22px' : '0' }"
          v-html="headText"
        />
        <div
          v-if="showRightBtn"
          class="close-btn absolute"
          @click="setCloseStatus"
          style="margin: -1rem; padding: 1rem;"
        >
          <img class="md:w-5" src="../../assets/common/close-icon.svg" alt="close button" />
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headText: String,
    headStyle: String,
    padding: {
      type: Boolean,
      default: false,
    },
    showRightBtn: {
      type: Boolean,
      default: false,
    },
    showLeftBtn: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [String, Number],
      default: '60%',
    },
    noHead: Boolean,
  },
  methods: {
    setCloseStatus() {
      if (!this.showRightBtn) return;
      this.$emit('set-close-status');
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes heightAnimation {
  from {
    opacity: 0.6;
    transform: translateY(100%);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.overlay {
  background-color: rgba(38, 38, 38, 0.6);
}

.card-wrapper {
  max-height: 99%;
  max-height: calc(99% - env(safe-area-inset-top));
  min-height: 60%;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding-bottom: env(safe-area-inset-bottom);
  animation: heightAnimation 0.5s ease-out;
}

.close-btn {
  top: 8px;
  right: 32px;
}

.back-btn {
  top: 8px;
  left: 32px;
}
</style>
